/* eslint-disable react/prop-types */
import React from 'react';
import './MainFields.scss'
import moment from 'moment';
import { STATUS_MAP, STATUS_MAP_REVERSE } from '../../../components/quotationsTable/Constants';
import { useSourcesData } from '../../../hooks/fetch-hooks/get-sources';
import { PRESORTED, STRIPS } from '../../../utils/constants';

const MainFields = ({ messages, status, updateOrderData, startDate, prescriptionDate, endDate, noOfDays, drName, source, channel, partnerId, orderType, isEditable, partners, partnersLoading }) => {
    const quotationStatuses = Object.values(STATUS_MAP);

    // Get sources data using the hook
    const { channels, isLoading: channelsLoading, getSourcesForChannels } = useSourcesData();

    // Get available channels for the selected source
    const availableSources = channel ? getSourcesForChannels(channel) : [];

    // Set default source when sources data loads and no source is set
    // useEffect(() => {
    //     if (channels.length > 0 && !channel) {
    //         updateOrderData(channels[0], 'channel');
    //     }
    // }, [channels, channel, updateOrderData]);

    return (
        <div className='bg-[white] px-5 py-5 rounded-lg border border-gray-300' >
            {
                messages?.map((message, key) => {
                    return (
                        <p key={key} className='text-[red] text-bold' > {message.text}</p>
                    )
                })
            }
            <br />
            <div className='relative bg-[white] rounded-lg flex flex-row flex-wrap gap-5' >
                <div className='flex flex-col flex-grow' >
                    <label className='main-fields_label' >Doctor Name</label>
                    <input type='text' name='drName' value={drName} onChange={(e) => updateOrderData(e.target.value, e.target.name)} className='rounded-md main-fields_input' disabled={!isEditable} />
                </div>
                <div className='flex flex-col flex-grow' >
                    <label className='main-fields_label' >Prescription Date</label>
                    <input type='date' name='date' value={moment(prescriptionDate).format('YYYY-MM-DD')} onChange={(e) => updateOrderData(moment(e.target.value).format(), e.target.name)} className='rounded-md main-fields_input' disabled={!isEditable} />
                </div>
                <div className='flex flex-col flex-grow' >
                    <label className='main-fields_label' >Start Date</label>
                    <input type='date' name='startDate' value={startDate} onChange={(e) => updateOrderData(e.target.value, e.target.name)} className='rounded-md main-fields_input' disabled={!isEditable} />
                </div>
                <div className='flex flex-col flex-grow' >
                    <label className='main-fields_label' >Duration</label>
                    <input type='number' min={1} name='noOfDays' value={noOfDays} onChange={(e) => updateOrderData(parseInt(e.target.value), e.target.name)} className='rounded-md main-fields_input' disabled={!isEditable} />
                </div>
                <div className='flex flex-col flex-grow' >
                    <label className='main-fields_label' >End Date</label>
                    <input type='date' name='endDate' disabled value={endDate} className='rounded-md main-fields_input opacity-50' />
                </div>
                <div className='flex flex-col flex-grow' >
                    <label className='main-fields_label' >Status</label>
                    <select className="rounded-lg h-10" name='status' value={status} onChange={(e) => updateOrderData(e.target.value, e.target.name)} disabled={!isEditable} >
                        {
                            quotationStatuses.map((status, index) => {
                                return (
                                    <option key={index} value={STATUS_MAP_REVERSE[status]}>{status}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className='flex flex-col ' >
                    <label className='main-fields_label' >Channel</label>
                    <select
                        className="rounded-lg h-10"
                        name='channel'
                        value={channel || ''}
                        onChange={(e) => updateOrderData(e.target.value, e.target.name)}
                        disabled={channelsLoading || !isEditable}
                    >
                        <option value="">Select Channel</option>
                        {channels.map((channelOption) => (
                            <option key={channelOption} value={channelOption}>
                                {channelOption}
                            </option>
                        ))}
                    </select>
                </div>
                <div className='flex flex-col ' >
                    <label className='main-fields_label' >Source</label>
                    <select
                        className="rounded-lg h-10"
                        name='source'
                        value={source || ''}
                        onChange={(e) => updateOrderData(e.target.value, e.target.name)}
                        disabled={!channel || availableSources.length === 0 || !isEditable}
                    >
                        <option value="">
                            {!channel ? 'Select Channel First' : 'Select Channel'}
                        </option>
                        {availableSources.map((sourceOption) => (
                            <option key={sourceOption} value={sourceOption}>
                                {sourceOption}
                            </option>
                        ))}
                    </select>
                </div>
                {channel === "B2B" && <div className='flex flex-col ' >
                    <label className='main-fields_label' >Partner</label>
                    <select
                        className="rounded-lg h-10"
                        name='partnerId'
                        value={partnerId}
                        disabled={!isEditable || partnersLoading}
                        onChange={(e) => {
                            const newPartnerId = e.target.value ? parseInt(e.target.value) : null;

                            // Update partnerId first
                            updateOrderData(newPartnerId, e.target.name);

                            const currentOrderTypeBase = orderType?.replace('PARTNER_', '').replace('INTERNAL_', '') || '';
                            // Then update the order type based on partner selection
                            if (!newPartnerId) {
                                // No partner selected - convert to INTERNAL
                                if (currentOrderTypeBase) {
                                    updateOrderData(`INTERNAL_${currentOrderTypeBase}`, 'type');
                                }
                            } else {
                                // Partner selected - convert to PARTNER
                                if (currentOrderTypeBase) {
                                    updateOrderData(`PARTNER_${currentOrderTypeBase}`, 'type');
                                }
                            }
                        }}
                    >
                        <option value="">
                            {partnersLoading ? 'Loading Partners...' : 'Select Partner'}
                        </option>
                        {partners.map((partnerOption) => (
                            <option key={partnerOption.id} value={partnerOption.id}>
                                {partnerOption.name}
                            </option>
                        ))}
                    </select>
                </div>}
                <div className='flex flex-col ' >
                    <label className='main-fields_label'>Order Type</label>
                    <select
                        className="rounded-lg h-10"
                        disabled={!isEditable}
                        name="type"
                        required
                        value={orderType?.replace('INTERNAL_', '').replace('PARTNER_', '') || ''}
                        onChange={(e) => {
                            const currentPrefix = orderType?.includes('PARTNER_') ? 'PARTNER_' : 'INTERNAL_';
                            updateOrderData(`${currentPrefix}${e.target.value}`, e.target.name);
                        }}
                    >
                        <option value="">Select Order Type</option>
                        <option value={PRESORTED}>Presorted</option>
                        <option value={STRIPS}>Strips</option>
                    </select>
                </div>
            </div>
        </div>
    )
}

export default MainFields;